var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "max-dialog" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "取消订单提醒",
            width: "890px",
            "append-to-body": true,
            visible: _vm.showDialog,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.showDialog = $event
            }
          }
        },
        [
          _c("div", [
            _c("span", { staticClass: "title" }, [
              _vm._v("当前选中订单取消统计")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "title" }, [
              _vm._v("子订单数："),
              _c("span", { staticClass: "title-num" }, [
                _vm._v(_vm._s(_vm.table.detail_count))
              ])
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "title" }, [
              _vm._v("主订单数："),
              _c("span", { staticClass: "title-num" }, [
                _vm._v(_vm._s(_vm.table.main_count))
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "day-main-body" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.table.list, stripe: "" }
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "index", label: "序号", width: "50" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "编号", width: "125" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.serial_number
                              ? _c("span", [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        scope.row.serial_number
                                          .split("-")
                                          .slice(3)
                                          .join("-")
                                      ) +
                                      "\n          "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isZhifa && scope.row.courier_name
                              ? _c("span", [
                                  _vm._v(
                                    "(" + _vm._s(scope.row.courier_name) + ")"
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isFactory && scope.row.courier_name
                              ? _c("span", [
                                  _vm._v(
                                    "(" + _vm._s(scope.row.courier_name) + ")"
                                  )
                                ])
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      property: "main_number",
                      label: "主订单号",
                      width: "125"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      property: "order_number",
                      label: "子订单号",
                      width: "125"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      property: "ruigu_code",
                      label: "商品编码",
                      width: "100"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { property: "name", label: "商品名称" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { property: "amount", label: "数量", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { property: "updated_at", label: "取消时间" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", [
            _c("span", { staticClass: "tips" }, [
              _c("i", { staticClass: "el-icon-warning" }),
              _vm._v(" 提示：上述订单已被客户取消，请务必检查备货情况")
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c("span", { staticClass: "tip" }, [
              _vm._v("如：1.请检查实物 ->2.重新打包 ->3.系统操作")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "export" }, [
            _c(
              "div",
              { staticClass: "export-btn", on: { click: _vm.exportExcel } },
              [
                _c("div", [
                  _c("i", { staticClass: "el-icon-download" }),
                  _vm._v(" 导出Excel")
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("(取消订单信息明细)")])
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.cancelHandler } }, [
                _vm._v("取消" + _vm._s(_vm.btnText))
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmHandler }
                },
                [_vm._v("确认" + _vm._s(_vm.btnText))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45576e62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45576e62","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/OrderCancelDialog.vue
// module id = null
// module chunks = 